<template>
  <div class="isolate">
    <Iphone17EventPage v-if="isIphone17EventPage" />
    <ProductJapan v-else-if="isJapanProductPage" />
    <Product v-else />
  </div>
</template>

<script setup lang="ts">
import { useRoute, useRuntimeConfig } from '#imports'
import { computed, defineAsyncComponent } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

const Product = defineAsyncComponent(
  () => import('~/scopes/product/pages/Product.vue'),
)
const ProductJapan = defineAsyncComponent(
  () => import('~/scopes/product/pages/Product-JP/Product-JP.vue'),
)
const Iphone17EventPage = defineAsyncComponent(
  () =>
    import('~/scopes/product/pages/Iphone17EventPage/Iphone17EventPage.vue'),
)

const route = useRoute()
const experiments = useExperiments()
const { market } = useMarketplace()
const { FF_PRODUCT_PAGE_IPHONE_17_EVENT_PAGE = '' } = useRuntimeConfig().public

const isJapanProductPage = computed(
  () =>
    market.countryCode === MarketCountryCode.JP &&
    experiments['experiment.ppJapanWeek'] === 'japanPP',
)

const isIphone17EventPage = computed(() => {
  return (
    route.params.slug === 'iphone-17' &&
    FF_PRODUCT_PAGE_IPHONE_17_EVENT_PAGE.includes(market.countryCode)
  )
})
</script>
